<template>
  <div>

    <submit-declarations-modal
      v-if="showDeclarationModal"
      id="modal-submit-for-clearance"
      clearance
      :shipment="shipment"
      :selected-parcels="selectedParcels"
      :selected-containers="selectedContainers"
      :selected-all="selectedAll"
      :declaration-type="declarationType"
      @submit="submit"
    />

    <b-row>
      <b-col
        class="mt-2"
        sm="5"
        md="5"
        lg="4"
      >
        <b-card-text>
          Parcels that for that declaration is lodged to customs, waiting for arrival.
        </b-card-text>
      </b-col>
      <b-col class="text-right">
        <b-button
          :disabled="containers.length === 0 || warehouseExcelLoading"
          variant="outline-success"
          @click="handleWarehouseExcelDownload"
        >
          Download Excel for warehouse
          <b-spinner
            v-if="warehouseExcelLoading"
            small
            class="ml-1"
          />
        </b-button>
        <b-button
          v-b-modal.modal-submit-for-clearance
          variant="outline-success"
          class="m-1"
          :disabled="disabledH7Btn"
          @click="showDeclarationModal = true"
          @close="showDeclarationModal = false"
        >
          Send presentation notices
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>

        <parcels-tree
          :shipment="shipment"
          :containers="containers"
          filter="waitingForArrival"
          clearance="true"
          :data-loading="loading"
          @sortDesc="fetchData(null, true, $event)"
          @selection="selection"
          @updateFilters="applyFilters"
        />

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCardText,
  BCol,
  BRow, BSpinner,
} from 'bootstrap-vue'
import ParcelsTree from '@/views/shipments/declarations/ParcelsTree.vue'
import SubmitDeclarationsModal from '@/views/shipments/declarations/SubmitDeclarationsModal.vue'
import { EventBus } from '@core/utils/utils'
import { searchQuery } from '@core/utils/filter'
import excelDownloadMixin from '@/mixins/excelDownloadMixin'

export default {
  components: {
    BSpinner,
    BButton,
    BCardText,
    BCol,
    BRow,
    ParcelsTree,
    SubmitDeclarationsModal,
  },
  mixins: [excelDownloadMixin],
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    shipment: {
      type: Object,
      required: true,
    },
    declarationType: {
      type: String,
      default: 'h7',
    },
  },
  data() {
    return {
      containers: [],
      selectedAll: false,
      showDeclarationModal: false,
      selectedContainers: [],
      selectedParcels: [],
      loading: false,
    }
  },
  computed: {
    disabledH7Btn() {
      return this.selectedAll === false && this.selectedContainers.length === 0 && this.selectedParcels.length === 0
    },
  },
  watch: {
    filters() {
      this.fetchData()
    },
    sortBy() {
      this.fetchData()
    },
    isSortDirDesc() {
      this.fetchData()
    },
  },
  created() {
    this.localFilters = { ...this.filters }
    // When the URL carries tree filters, ParcelsTree drives the single filtered
    // fetch on mount, so skip the initial (unfiltered) fetch here to avoid a
    // duplicate request.
    const q = this.$route.query || {}
    const hasTreeFilters = !!(q.tracking_number || q.container_code || q.mrn || q.lrn)
    if (!hasTreeFilters) this.fetchData()
    EventBus.$on('general-declaration-update', this.fetchData)
    EventBus.$on('renewDeclarationList', this.handleRenewDeclarationList)
  },
  beforeDestroy() {
    EventBus.$off('general-declaration-update', this.fetchData)
    EventBus.$off('renewDeclarationList', this.handleRenewDeclarationList)
  },
  methods: {
    handleRenewDeclarationList() {
      this.fetchData()
      EventBus.$emit('refresh-statistics')
    },
    fetchData(activeTab, showLoader = true, sortDesc = null) {
      if (!activeTab || activeTab === 'waiting-arrival') {
        if (showLoader) {
          this.loading = true
        }
        this.$http.get(searchQuery(`/v1/companies/${this.$activeCompany().data.company.id}/shipments/${this.shipment.id}/declarations/waiting-for-arrival`, this.localFilters), {
          params: {
            sortBy: 'container',
            sortDesc: sortDesc,
          },
        })
          .then(response => {
            this.containers = response.data.data
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    selection(data) {
      this.selectedAll = data.selectedAll
      this.selectedContainers = data.selectedContainers
      this.selectedParcels = data.selectedParcels
    },
    submit(data) {
      this.$http.post(`/v1/companies/${this.$activeCompany().data.company.id}/shipments/${this.shipment.id}/declarations/arrivals`, {
        all: this.all,
        containers: this.selectedContainers,
        parcels: this.selectedParcels,
        previous_document_type: data.previous_document_type,
        previous_document_category: data.previous_document_category,
        previous_document_reference: data.previous_document_reference,
        send_arrived_to_facility: data.send_arrived_to_facility,
        warehouse_id: data.warehouse_id,
        customs_country: data.customs_country,
        previous_document_number_of_items: data.previous_document_number_of_items,
      })
        .then(() => {
          EventBus.$emit('refresh-statistics')
        })
    },
    applyFilters(newFilters) {
      this.localFilters = newFilters
      this.fetchData()
    },
    downloadUrl() {
      return `${process.env.VUE_APP_API_URL}/v1/companies/${this.$activeCompany().data.company.id}/shipments/${this.shipment.id}/declarations/waitingForArrival`
    },
    excelDownloadUrl() {
      return `${this.downloadUrl}/excel`
    },
    warehouseExcelUrl() {
      return `${this.downloadUrl}/excel-for-warehouse`
    },
  },
}
</script>

<style scoped>

</style>
